import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { CategoriaService } from '../../../services/categoria/categoria.service';
import { CarritoService } from '../../../services/carrito/carrito.service';
import { IArchivo } from '../../../../model/interface/IArchivo';
import { ICategoria } from '../../../../model/interface/ICategoria';
import { IProducto } from '../../../../model/interface/IProducto';
import { ElementoCarro } from '../../../../model/interface/ElementoCarro';
import * as _ from 'lodash';
import { PreviewFantasyCategoryService } from '../../../services/preview-fantasy-category/preview-fantasy-category.service';

@Component({
  selector: 'app-categoria-especial',
  templateUrl: './categoria-especial.component.html'
})
export class CategoriaEspecialComponent implements OnInit {

  types = {
    catalogo : 'CAT_ESP_CATALOGO',
    imgVertical: 'CAT_ESP_IMAGEN_ANEXA_VAERTICAL',
    imgHorizontal: 'CAT_ESP_IMAGEN_ANEXA_HORIZONTAL',
    productos: 'PRODUCTO',
    banner: 'CAT_ESP_BANNER',
    imgGaleria: 'CAT_ESP_IMAGEN_GALERIA',
    videoGaleria: 'CAT_ESP_VIDEO_GALERIA'
  };

  categoriaEspId: number;
  categoriaEsp: ICategoria;
  productos: ElementoCarro[] = [];
  ordenProductos = 'destacados';

  archivosTodos: IArchivo[] = [];
  banners: IArchivo[] = [];
  imgGaleria: IArchivo[] = [];
  videosGaleria: IArchivo[] = [];
  itemsGaleria: IArchivo[] = [];
  listaItems: any[]= [];


  constructor(
    private _categoriaService: CategoriaService,
    private _carritoService: CarritoService,
    private activatedRoute: ActivatedRoute,
    private previewFantasyCategoryService: PreviewFantasyCategoryService
  ) {
    this.activatedRoute.params.subscribe( params => {
      // Si solo cambia la categoria hija
      this.categoriaEspId = params.id;
      this.ngLoadData();
    });
  }

  ngOnInit() {
    this.previewFantasyCategoryService.borrar();
  }


  ngLoadData() {


    const observeProductos = this._categoriaService.getProductos(this.categoriaEspId);
    const observeArchivos =  this._categoriaService.getArchivos(this.categoriaEspId);

    forkJoin([observeProductos, observeArchivos])
      .subscribe(data => {
        /**
         * Productos
         * */
        console.log('Productos', data[0]);
        this.productos = this._carritoService.enriquecerProductos(data[0]);
        this._carritoService.carroProductos
          .subscribe( () => {
            this.productos = this._carritoService.actualizarProductos(this.productos);
          });

        /**
         * Archivos
         * */
        this.archivosTodos = data[1];

        this.banners = _.filter(this.archivosTodos, {'tipo': this.types.banner});
        this.imgGaleria = _.filter(this.archivosTodos, {'tipo': this.types.imgGaleria});
        this.videosGaleria = _.filter(this.archivosTodos, {'tipo': this.types.videoGaleria});

        this.itemsGaleria = _.orderBy(_.union(this.imgGaleria, this.videosGaleria), 'orden');

        this.generarListaElementos();
      });

    this._categoriaService.get(this.categoriaEspId)
      .subscribe(data => {
        this.categoriaEsp = data;
      });
  }

  generarListaElementos() {
    this.listaItems = [];
    const nuevosElementos = [];
    _.each(this.productos, (producto) => {
      nuevosElementos.push({type: this.types.productos, data: producto, orden: producto.producto.ordenEn});
    });


    const archivos = _.filter(this.archivosTodos, (o) => {
      if (o.tipo === this.types.catalogo || o.tipo === this.types.imgVertical || o.tipo === this.types.imgHorizontal) {
        return o;
      }
    });

    for (const file of archivos) {
      nuevosElementos.push({type: file.tipo, data: file, orden: file.orden});
    }


    this.listaItems = _.orderBy(nuevosElementos, 'orden');
  }

  ordenarProductos() {}

  agregarProductoCotizacion(producto: ElementoCarro) {
    const clon = _.clone(producto);
    this._carritoService.agregarProducto(clon);
  }

  quitarProductoCotizacion(producto: ElementoCarro) {
    const clon = _.clone(producto);
    this._carritoService.quitarProducto(clon);
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/shared/categoria-especial/categoria-especial.component.ts